export const fixFileName = file => {
  if (!file || !file.name) {
    throw Error('Invalid file');
  }

  return file.name.replaceAll('#', '');
};
